import { createContext, useContext } from "react";
export const EventContextReact = createContext(null);
export const useEventContext = () => {
    const ctx = useContext(EventContextReact);
    if (ctx === null) {
        throw new Error('useEventContext must be used within EventContextReact.Provider');
    }
    return ctx;
};
